import * as React from 'react'
import { Icon, Message } from '@alifd/next';
import Countdown from 'react-countdown';

import './index.scss';

const {useState} = React;

export default function Index(props: { availableActivity: any; activitySellLimitText: any; i18n: any; }) {
  const {availableActivity, activitySellLimitText, i18n} = props;
  // 库存小于moq
  if (activitySellLimitText) {
    return <Message type="notice">{activitySellLimitText}</Message>
  }
  if (!availableActivity) return null;
  const {endTime, promotionContent} = availableActivity;
  const [complete, setComplete] = useState(false);

  const renderCount = (data: { hours: any; minutes: any; seconds: any; days: any; completed: any}) => {
      const { days, hours, minutes, seconds, completed } = data;
      setComplete(completed);
      return <span className="active-date">{days}d:{hours}h:{minutes}m:{seconds}s</span>
  };

  if (complete) return null;
  
  return (
    <div className="product-activity">
      <span className="active-percen">{i18n["undue_market_action.coupon.off"].replace('{0}', `${promotionContent}%`)}</span>
      <span className="active-discount">{i18n["marketAction_activity_endTime"]}</span>
      <Icon type="clock" />
      <Countdown
        date={endTime}
        renderer={renderCount}
      />
    </div>
  )
}
